export class DropdownOptionModel {
    public constructor(
        public title: string = "",
        public value: any = null
    ) {
    }
}
